import { Select } from "@shopify/polaris";

import { t } from "../lib/i18n";
import type { LineSortKey } from "../utils/lineSort";

interface Props {
  value: LineSortKey;
  onChange: (value: LineSortKey) => void;
  /** 画面ごとに「並びがどこまで効くか」が違うので呼び出し側が書く。 */
  helpText: string;
}

/**
 * 明細の並び順ピッカー。発注書（下書き）と入荷の両方で使う。
 *
 * 🔴 選択肢のラベルは**この関数の中で** `t()` を呼ぶ。モジュール直下の const に
 * すると `initLocale()` より前に評価され、英語UIでも日本語のまま出る（既知の罠）。
 */
export function LineSortSelect({ value, onChange, helpText }: Props) {
  const options = [
    { label: t("既定（並べ替えない）"), value: "default" },
    { label: t("SKU順"), value: "sku" },
    { label: t("商品名順"), value: "title" },
    { label: t("数量の多い順"), value: "qty" },
  ];

  return (
    <Select
      label={t("明細の並び順")}
      options={options}
      value={value}
      onChange={(next) => onChange(next as LineSortKey)}
      helpText={helpText}
    />
  );
}
